/**
 * StickyCTA
 *
 * Also uses .js-care-popup-form in SendForm.js
 * to set a cookie and GTM event if form was sent
 * 
 * @since 1.0.0
 */
import Cookies from 'js-cookie'

const CarePopup = () => {
  window.addEventListener( 'load', () => {

    const container = document.querySelector('.js-care-popup')
    if (!container) return

    const close = container.querySelector('.js-care-close')
    const open = container.querySelector('.js-care-open')
    if (!close || !open) return

    // Grab page title from data attribute
    let pageTitle = container.dataset.pagetitle
    if ( ! pageTitle ) {
      pageTitle = 'Onbekend'
    }

    // Grab language from data attribute
    let language = container.dataset.language
    if ( ! language ) {
      language = 'Onbekend'
    }

    // Don't show popup if have cookie
    if (Cookies.get('bright_care_popup')) {
      return
    }

    // Save currentTime+30s in session
    if ( ! sessionStorage.getItem('care_popup')) {
      let now = new Date()
      const timeToTrigger = now.setSeconds(now.getSeconds() + 30)
      sessionStorage.setItem('care_popup', timeToTrigger)
    }

    // Show popup after 30s
    if ( sessionStorage.getItem('care_popup') ) {

      let timer = setInterval(() => {
        if (sessionStorage.getItem('care_popup') < new Date() ) {
          container.classList.add('active')
          clearInterval(timer)
        }
      }, 1000)
    }

    // Remove popup after clicking away
    close.addEventListener('click', e => {
      e.preventDefault()
      container.classList.remove('active')

      // set cookie to show it was clicked_away
      Cookies.set('bright_care_popup', 'rejected', { expires: 3 })

      // gtm event
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'rejectedZorgPopup',
        pagetitle: pageTitle,
        language: language
      })

      // remove session
      sessionStorage.removeItem('care_popup')
    })

    // Remove popup after clicking button
    open.addEventListener('click', e => {
      container.classList.remove('active')

      // set cookie to show the button was clicked
      Cookies.set('bright_care_popup', 'accepted', { expires: 30 })

      // gtm event
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'acceptedZorgPopup',
        pagetitle: pageTitle,
        language: language
      })

      // remove session
      sessionStorage.removeItem('care_popup')
    })

  }) // onLoad
}

export default CarePopup



// WEBPACK FOOTER //
// ./src/js/modules/CarePopup.js